import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import { UrlIsoDashboardStore } from '../../stores/DashboardStore';
import { ConsolePage, ConsolePageTitle } from '../ConsoleFragments';
import WidgetCounter from '../Widget/WidgetCounter';
import WidgetLineChart from '../Widget/WidgetLineChart';
import WidgetMultipleCounters from '../Widget/WidgetMultipleCounters';
import WidgetList from '../Widget/WidgetList';
import WidgetWrapper from './WidgetWrapper';
import FuseButton from '../FuseControls/FuseButton';
import FileDownloadModal from './FileDownloadModal';
import ConsoleStore from '../../stores/ConsoleStore';
import './Dashboard.css';

const block = b.lock('Dashboard');

class URLIsoDashboard extends Component {
    static propTypes = {
        urlIsoDashboard: UrlIsoDashboardStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };

    componentDidMount() {
        this.props.urlIsoDashboard.update();
    }

    componentWillUnmount() {
        this.props.urlIsoDashboard.stopUpdate();
    }

    getSummaryWidgets = () => {
        const { urlIsoDashboard } = this.props;
        return [{
            title: 'TOTAL REDIRECTS',
            info: 'Total number of redirects from TAP URL Defense to URL Isolation',
            store: urlIsoDashboard.totalRedirects,
            exact: true,
        }, {
            title: 'TOTAL THREATS BLOCKED',
            info: 'Total number of malware and phishing threats blocked',
            store: urlIsoDashboard.totalThreatsBlocked,
            exact: true,
        }];
    };

    getThreatWidgets = () => {
        const { urlIsoDashboard } = this.props;
        return [{
            title: 'UPLOAD ATTEMPTS PREVENTED',
            info: 'The number of upload attempts detected by Proofpoint Isolation for all users',
            store: urlIsoDashboard.counters.uploads,
        }, {
            title: 'DOWNLOAD ATTEMPTS PREVENTED',
            info: 'The number of downloads attempts detected by Proofpoint Isolation for all users',
            store: urlIsoDashboard.counters.downloads,
        }, {
            title: 'ISOLATED JAVASCRIPT SOURCES',
            info: 'The number of external JavaScript sources removed by Proofpoint Isolation for all users',
            store: urlIsoDashboard.counters.scripts,
        }];
    };

    render() {
        const { urlIsoDashboard, console } = this.props;
        const reportDownload = urlIsoDashboard.reportDownload;
        const isPPTEnabled = console.isMirrorFeatureEnabled('CREATE_PPT');
        return <ConsolePage>
            {isPPTEnabled && console.isSuperAdmin ? <Fragment>
                <ConsolePageTitle className={block('TitleWrapper')}>
                    <span className={block('TitleText')}>Dashboard - URL Isolation</span>
                    <FuseButton
                        type={FuseButton.type.PRIMARY}
                        color={FuseButton.color.BLUE}
                        icon={'material_download'}
                        onClick={reportDownload.openModal}
                        qa={'url-iso-download-report'}
                    >Executive Report</FuseButton>
                </ConsolePageTitle>
            </Fragment> : <ConsolePageTitle>Dashboard - URL Isolation</ConsolePageTitle>}

            <div className={block('Row')}>
                {this.getSummaryWidgets().map(({ title, info, store, exact }) => <WidgetWrapper key={title} size={25}>
                    <WidgetCounter
                        store={store}
                        exact={exact}
                        title={title}
                        infoTitle={title}
                        infoBody={info}
                    />
                </WidgetWrapper>)}
            </div>
            <ConsolePageTitle>Redirect Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={100}>
                    <WidgetLineChart
                        store={urlIsoDashboard.redirects}
                        title="REDIRECTS TO ISOLATION"
                        total1="Total Redirects"
                    />
                </WidgetWrapper>
            </div>
            <ConsolePageTitle>Threat Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={100}>
                    <WidgetLineChart
                        store={urlIsoDashboard.threatsBlocked}
                        title={<Fragment>THREATS BLOCKED<br />(Malware and Phishing)</Fragment>}
                        total1="Total Threats Blocked"
                    />
                </WidgetWrapper>
                {this.getThreatWidgets().map(({ title, info, store }) => <WidgetWrapper key={title} size={33}>
                    <WidgetMultipleCounters
                        title={title}
                        infoTitle={title}
                        infoBody={info}
                        store={store}
                        label="Total"
                        loading={urlIsoDashboard.counters.updateState.isLoading}
                    />
                </WidgetWrapper>)}
            </div>
            <ConsolePageTitle>Activity Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={50}>
                    <WidgetList
                        store={urlIsoDashboard.topSitesVisited}
                        title="TOP URLs VISITED"
                        indexTitle="Rank"
                        labelTitle="URL Visited"
                        valueTitle="Visited"
                    />
                </WidgetWrapper>
                <WidgetWrapper size={50}>
                    <WidgetList
                        store={urlIsoDashboard.topSitesBlocked}
                        title="CONTENT FILTERING"
                        indexTitle="Rank"
                        labelTitle="URL Blocked"
                        valueTitle="Blocked"
                    />
                </WidgetWrapper>
            </div>
            <FileDownloadModal
                store={reportDownload}
            />
        </ConsolePage>;
    }
}

export default inject('urlIsoDashboard', 'console')(observer(URLIsoDashboard));

